import { memo } from 'react';
import SharedClipPageHeader from './SharedClipPageHeader';
import { Clip } from '@/domains/asset';
import ErrorContainer, { ErrorContainerProps } from '@/App/ErrorBoundary/ErrorContainer';

function SharedClipErrorPage({ error }: { error: ErrorContainerProps }) {
  return (
    <>
      <SharedClipPageHeader clip={{} as Clip} />
      <ErrorContainer errorMessage={error.errorMessage} errorDisplayCode={error.errorDisplayCode} />
    </>
  );
}

export default memo(SharedClipErrorPage);
